module.exports = __webpack_public_path__ + "img/EQA_logo.0125e5a0.png";